export function getTagVariantForFulfilmentStatus(status) {
  const statusVariants = {
    in_progress: 'primary-orange',
    unfulfilled: 'primary-danger',
    fulfilled: 'primary-green',
    draft: 'primary-orange',
    upcoming: 'primary-orange',
    on_hold: 'primary-neutral',
    picking: 'primary-neutral',
    packing: 'primary-neutral',
    ready_to_ship: 'primary-blue',
    shipped: 'primary-green',
    cancelled: 'primary-danger',
    ready_to_pickup: 'primary-blue',
    picked_up: 'primary-blue',
    in_transit: 'primary-orange',
    in_creation: 'primary-orange',
    issue: 'primary-danger'
  }

  return statusVariants[status] || 'primary-neutral'
}
